import { CheckMarkIcon, DoubleCheckMarkIcon } from '@assets/icons';
import { TimeIcon } from '@chakra-ui/icons';
import { Box, Flex, Tag, Text } from '@chakra-ui/react';

export const detailItem = ({ label = null, value = null, isError = false }) => (
    <Flex alignItems={'center'} gap={'16px'}>
        <Text fontSize={'xs'} fontWeight={'700'} flex={1}>
            {label}
        </Text>
        <Text fontWeight="medium" color={isError ? 'danger.500' : 'semantic.500'} flex={2.3}>
            {value}
        </Text>
    </Flex>
);

export const detailItemTag = ({ label = null, value = null, variant = 'draft', isError = false }) => {
    const lower = value?.toLowerCase?.();

    const iconMap = {
        done: <DoubleCheckMarkIcon size={16} />,
        processing: <TimeIcon size={16} />,
        'ready to claim': <CheckMarkIcon size={16} />,
    };

    const icon = iconMap[lower];

    const tagValue = (
        <Flex gap="8px" alignItems="center" textTransform="capitalize">
            {icon} {value}
        </Flex>
    );

    return (
        <Flex alignItems="center" gap="16px">
            <Text fontSize={'xs'} fontWeight="700" flex={1}>
                {label}
            </Text>

            <Box flex={2.3}>
                <Tag
                    fontWeight="medium"
                    maxW="fit-content"
                    variant={variant}
                    color={isError ? 'danger.500' : 'semantic.500'}
                    boxShadow={isError ? 'inset 0 0 0px 1px #e6001c' : 'none'}
                    textTransform="capitalize"
                >
                    {icon ? tagValue : value}
                </Tag>
            </Box>
        </Flex>
    );
};
